import {OrderState} from "@/model/OrderState";
import {OrderProduct} from "@/model/OrderProduct";
import {PackageCollectionStatus} from "@/model/collection/PackageCollectionStatus";
import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import {UpdateOrderRequirements} from "@/model/UpdateOrderRequirements";

export class Order implements Serializable {

    orderId: string;
    orderNumber: string;
    storeId: string;
    zone: string;
    status: OrderState;
    collectionStatus: PackageCollectionStatus;
    pickupDate: Date;
    dueDate: Date;
    processingDate: Date;
    emergencyDate: Date;
    collectionDate: Date;
    deliveryDate: Date;
    products: OrderProduct[];
    customerLastName: string;
    customerId: number;
    urgent: boolean = false;
    type: string;
    channel: string;
    driveId: string;
    orderPickerId: string;
    orderPickerName: string;
    deliverySiteId: string;
    updateOrderRequirements: UpdateOrderRequirements;

    fromJSON(rawObject: any): void {
        SerializationHelper.copyNonExcludedProperties(this, rawObject, ['products']);

        if (rawObject['products'] != null) {
            this.products = SerializationHelper.toArrayInstanceFromJsonObjArray(() => new OrderProduct(), rawObject['products']);
        }
    }

    get isCateringService(): boolean {
        return this.channel === "TRAITEUR" && this.type === "HYPER";
    }
}
